<template>
  <div class="nav-bar">
    <ul :class="{ mobileActive: isMobileActive }">
      <li>
        <a class="inactive" :href="`${publicPath}proposal.pdf`">project proposal</a>
      </li>
      <li>
        <a class="inactive" :href="`${publicPath}slide-show`">slide show</a>
      </li>
      <li>
        <a class="inactive" :href="`${publicPath}monograph`">monograph</a>
      </li>
      <li class="menu" @click="isMobileActive = !isMobileActive">
        <Menu :isBurgerActive="isMobileActive" />
      </li>
    </ul>
  </div>
</template>

<script>
import Menu from './Menu.vue';
export default {
  name: 'NavBar',
  components: {
    Menu
  },
  data: () => ({
    isMobileActive: false,
    publicPath: process.env.BASE_URL
  })
};
</script>

<style lang="scss" scoped>
ul {
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  list-style-type: none;
  transition: background-color ease-out 0.2s;
}

.menu {
  display: none;
}

li {
  font-size: 1.5em;

  a {
    padding: 0.5em;
    text-decoration: none;
    color: #fa6940;
    display: block;
    height: 100%;

    display: flex;
    align-items: center;
  }

  a:hover {
    color: #f7fafcff;
    background-color: #fa6940;
    transition: color ease-in 0.2s, background-color ease-in 0.2s;
  }
}

@media only screen and (max-width: 600px) {
  ul {
    flex-direction: column;
    left: 0;
    right: 0;

    margin: 0;
    padding: 0;
    color: #f7fafcff;
  }

  .mobileActive {
    background-color: #fa6940;
    height: 100%;
    align-items: center;
    position: fixed;
    z-index: 10;

    transition: background-color ease-in 0.2s;
    li {
      display: initial;
      a {
        opacity: 1;
        transition: opacity ease-in 1s;
      }
    }
  }

  li {
    display: none;
    a {
      opacity: 0;
      color: #f7fafcff;
    }
  }

  .menu {
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0;
    margin: 1em;
    align-self: flex-end;
    order: -1;
  }
}
</style>
